



































































import Vue from 'vue';
import Button, {ButtonTypes} from '@common/button/button.vue';
import StarRating from '@components/old-home-page/destination-details/star-rating.vue';
import SkeletonWrapper from '@common/skeleton-wrapper.vue';
import {useRouter} from '@/router';
import BaseCard from './base-card.vue';
export default Vue.extend({
  components: {
    Button,
    StarRating,
    SkeletonWrapper,
    BaseCard,
  },
  name: 'DestinationDetailsCard',
  props: {
    category: String,
    title: String,
    subTitle: {
      type: String,
      default: null,
    },
    images: Array,
    isCoverImage: Boolean,
    rating: Number,
    priceLabel: String,
    price: String,
    matchedTags: Array,
    showTags: Boolean,
    showMatchAndPrice: {type: Boolean, default: () => true},
    isLoading: Boolean,
    detailsRoute: String,
    selectRoute: String,
  },
  data() {
    return {
      ButtonTypes,
    };
  },
  computed: {
    categoryClassName(): string {
      return `dest-details-card category-${this.category?.toLowerCase() || 'none'}`;
    },
    imagesList(): string[] {
      return (this.images as string[]) || [''];
    },
  },
  methods: {
    onDetailsClick() {
      const router = useRouter();
      router.push(this.detailsRoute);

      this.$emit('details-click');
    },
    onSelectClick() {
      const router = useRouter();
      router.push(this.selectRoute);

      this.$emit('select-click');
    },
  },
});
